import React from "react";
import "../../styles/css/footer.css"

const Text = () => {
  return (
    <div className="footer">
      <p>© 2023 Ukeh</p>
      <p>All Rights Reserved</p>
    </div>
  );
};

export default Text;
